var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: Boolean(_vm.action),
              expression: "Boolean(action)"
            }
          ],
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "220px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "min-width": "180px",
                    width: "100%",
                    height: "100%",
                    padding: "10px 0px 10px"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "min-height": "500px",
                      "padding-left": "16px"
                    },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.gridOptions,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers", staticStyle: { flex: "none" } },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "1" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "2" },
                                on: {
                                  click: function($event) {
                                    return _vm.onAdd()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isCooperate,
                                    expression: "!isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !_vm.editBtnEnabled,
                                  type: "success",
                                  no: "3"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler("edit")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isCooperate,
                                    expression: "isCooperate"
                                  }
                                ],
                                attrs: { type: "success", no: "4" },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler("edit")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "5" },
                                on: {
                                  click: function($event) {
                                    return _vm.copyJobHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.isCooperate,
                                    expression: "!isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !_vm.deleteBtnEnabled,
                                  type: "danger",
                                  no: "6"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                            ),
                            _vm.forecastApproval && !_vm.isCooperate
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.$checkPermission([
                                            "button_SIPREALERT_submit"
                                          ]),
                                          expression:
                                            "$checkPermission(['button_SIPREALERT_submit'])"
                                        }
                                      ],
                                      attrs: {
                                        disabled: !_vm.submitBtnEnabled,
                                        type: "primary",
                                        no: "7"
                                      },
                                      on: { click: _vm.submitHanlder }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Submit"))
                                      )
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.$checkPermission([
                                            "button_SIPREALERT_revoke"
                                          ]),
                                          expression:
                                            "$checkPermission(['button_SIPREALERT_revoke'])"
                                        }
                                      ],
                                      attrs: {
                                        disabled: !_vm.revokeBtnEnabled,
                                        type: "primary",
                                        no: "8"
                                      },
                                      on: { click: _vm.revokeHanlder }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Message.Withdraw")))]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.$checkPermission([
                                            "button_SIPREALERT_reject"
                                          ]),
                                          expression:
                                            "$checkPermission(['button_SIPREALERT_reject'])"
                                        }
                                      ],
                                      attrs: {
                                        disabled: !_vm.rejectBtnEnabled,
                                        type: "primary",
                                        no: "9"
                                      },
                                      on: { click: _vm.forecastRejectHandler }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                                  )
                                ]
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_SIPREALERT_siReportTransfer"
                                      ]) && !_vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_SIPREALERT_siReportTransfer']) && !isCooperate"
                                  }
                                ],
                                attrs: {
                                  disabled: !_vm.convertToRealEnabled,
                                  type: "primary",
                                  no: "10"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.convertToRealJobHandler()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.RegularBusiness"))
                                )
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: false && !_vm.isCooperate,
                                    expression: "false && !isCooperate"
                                  }
                                ],
                                attrs: { type: "primary", no: "11" },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_SIPREALERT_accept"
                                      ]) && _vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_SIPREALERT_accept']) && isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "12",
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.acceptCooperateHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.PassAudit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.$checkPermission([
                                        "button_SIPREALERT_reject"
                                      ]) && _vm.isCooperate,
                                    expression:
                                      "$checkPermission(['button_SIPREALERT_reject']) && isCooperate"
                                  }
                                ],
                                attrs: {
                                  no: "13",
                                  disabled: !(
                                    _vm.currentRow &&
                                    !_vm.isEditing &&
                                    [
                                      _vm.SystemConstants
                                        .COOPERATE_STATUS_PENDING.code
                                    ].includes(_vm.currentRow.cooperateStatus)
                                  ),
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.rejectHandler(1)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Refuse")))]
                            ),
                            _c(
                              "el-badge",
                              {
                                staticStyle: { "margin-left": "5px" },
                                attrs: {
                                  "is-dot": _vm.crossTenantDialog.readState
                                }
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.job.trustFromJob,
                                      type: "primary",
                                      no: "14"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.showChangeHistoryHandler()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ChangeHistory"))
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "15" },
                                on: { click: _vm.onPrint }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            )
                          ],
                          2
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isNew,
                                expression: "isNew"
                              }
                            ],
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "16" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "17" },
                                on: {
                                  click: function($event) {
                                    return _vm.cancelEdit(
                                      _vm.openMultiple
                                        ? _vm.goBackAtMultiple
                                        : _vm.goBack
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "edit",
                                expression: "action==='edit'"
                              }
                            ],
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "18" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "19" },
                                on: {
                                  click: function($event) {
                                    _vm.cancelEdit(
                                      _vm.openMultiple
                                        ? _vm.againLookAtMultiple
                                        : function() {
                                            _vm.againShow("look")
                                          }
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "SaveTheDefaultValues2",
                                  type: "primary"
                                },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            ),
                            _c("span", {
                              staticStyle: {
                                "font-size": "12px",
                                padding: "5px 9px",
                                color: "unset"
                              },
                              domProps: {
                                innerHTML: _vm._s(_vm.commonInfo.title)
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm.action === "look"
                        ? _c(
                            "div",
                            [
                              _c("CargoIm", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.imCacheKey && _vm.action === "look",
                                    expression: "imCacheKey && action==='look'"
                                  }
                                ],
                                ref: "cargoIm"
                              }),
                              _vm.forecastApproval
                                ? _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        padding: "5px 0",
                                        color: "#F56C6C"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobTitle))]
                                  )
                                : _vm._e(),
                              _c("span", {
                                staticStyle: {
                                  "font-size": "12px",
                                  padding: "5px 9px",
                                  color: "unset"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.commonInfo.title)
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "basicTab",
                                label: _vm.$t("SeaExport.ImportOperation")
                              }
                            },
                            [
                              _c("basic-tab", {
                                ref: "basicTab",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-cross-tenant-s-e-to-s-i":
                                    _vm.isCrossTenantSEToSI,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "processing-promise-list":
                                    _vm.processingPromiseList
                                },
                                on: {
                                  containerLoadTypeEvent:
                                    _vm.containerLoadTypeEvent
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "masterBasicTab",
                                label: _vm.$t("SeaExport.ImportOperation")
                              }
                            },
                            [
                              _c("master-basic-tab", {
                                ref: "masterBasicTab",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "is-cross-tenant-s-e-to-s-i":
                                    _vm.isCrossTenantSEToSI,
                                  "is-sea-export": true,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: {
                                  containerLoadTypeEvent:
                                    _vm.containerLoadTypeEvent
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: "tabArrivalInformation",
                          attrs: {
                            lazy: true,
                            name: "tabArrivalInformation",
                            label: _vm.$t("SeaExport.ArrivalInformation")
                          }
                        },
                        [
                          _c("tab-arrival-information", {
                            ref: "tabArrivalInformation",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "cooperate-edit": _vm.cooperateEditOther
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 3,
                          attrs: {
                            lazy: true,
                            name: "tabCharges",
                            label: _vm.$t("SeaExport.Charge")
                          }
                        },
                        [
                          _c("tab-charges", {
                            ref: "tabCharges",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "is-cross-tenant-se-to-si":
                                _vm.isCrossTenantSEToSI,
                              "view-source": "SiPrediction"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 4,
                          attrs: { lazy: true, name: "tabMBL", label: "MB/L" }
                        },
                        [
                          _c("tab-mbl", {
                            ref: "tabMBL",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "is-cross-tenant-s-e-to-s-i":
                                _vm.isCrossTenantSEToSI,
                              "cooperate-edit": _vm.cooperateEditOther
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 5,
                          attrs: { lazy: true, name: "tabHBL", label: "HB/L" }
                        },
                        [
                          _c("tab-hbl", {
                            ref: "tabHBL",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "is-cross-tenant-s-e-to-s-i":
                                _vm.isCrossTenantSEToSI,
                              "cooperate-edit": _vm.cooperateEditOther
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          key: 6,
                          attrs: {
                            lazy: true,
                            name: "tabContainer",
                            label: _vm.$t("SeaExport.ContainerInfo")
                          }
                        },
                        [
                          _c("tab-container", {
                            ref: "tabContainer",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "cooperate-edit": _vm.cooperateEditOther
                            }
                          })
                        ],
                        1
                      ),
                      !_vm.isNew
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _vm.rejectWindow.visible
        ? _c("reject-dialog", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.totalProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.crossTenantDialog.visible
        ? _c("cross-tenant-change-history-dialog", {
            attrs: {
              visible: _vm.crossTenantDialog.visible,
              data: _vm.crossTenantDialog.data,
              "has-un-read": _vm.crossTenantDialog.readState,
              "job-uuid": _vm.job.uuid,
              lob: _vm.job.lob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.crossTenantDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }